const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/account.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/account.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { UserManagementSkeleton } from '@/features/user-management/components/UserManagementSkeleton';
import { userDirectorySearchSchema } from '@/features/user-management/lib/userDirectorySearch';
import { userManagementDirectoryQuery } from '@/features/user-management/services/userManagementQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/user-management/account')({
  beforeLoad: requireCapabilities(has => has('users.list')),
  validateSearch: userDirectorySearchSchema,
  loaderDeps: ({
    search
  }) => ({
    q: search.q
  }),
  loader: async ({
    cause,
    context,
    deps
  }) => {
    const query = userManagementDirectoryQuery(deps.q);
    const hasCachedData = context.queryClient.getQueryState(query.queryKey)?.data !== undefined;
    if (cause === 'enter' && !hasCachedData) {
      await context.queryClient.ensureInfiniteQueryData(query);
    }
  },
  shouldReload: false,
  pendingComponent: UserManagementSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});